// @flow

import type { ConfigurationState } from './state'
import { parseStoreDate } from '../../../utils/date'

export default {
  customerGroupToUseForConfiguration: (state: ConfigurationState, getters: Object, rootState: Object, rootGetters: Object) => {
    const selectedCustomerGroup = state.selectedCustomerGroup
    const fallbackCustomerGroup = rootGetters['selection/customerGroupToShowForProduct'](state.selectedProduct)
    return selectedCustomerGroup || fallbackCustomerGroup
  },
  startDate: (state: ConfigurationState) => {
    let defaultDate = new Date()

    if (state.coveredPeriod) {
      const coveredPeriodStart = parseStoreDate(state.coveredPeriod.start)
      defaultDate = coveredPeriodStart && coveredPeriodStart > defaultDate ? coveredPeriodStart : defaultDate
    }

    return state.dateEffective ? parseStoreDate(state.dateEffective) : defaultDate
  },
  sessionId: (state: ConfigurationState) => {
    return state.sessionId
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/configuration/getters.js